export const excelName = '货位资料'
export const headerData = ['区域', '显示货位', '货位编号', '巷道',
  '排','列','层', '深度', '货位类型','存放类型','货架类型',
  '容量','存放状态','货位状态','销售分类','码放类型','逻辑区域',
  '长','宽','高','占用容量','输送线','货主','重量','短编号','是否容器控制',
  '是否自动货位','是否锁定','是否可用']
export const filterVal = ['zone', 'name', 'no', 'roadway',
  'x', 'z', 'y', 'depth','locationType','storageType','rackType'
  ,'capacity','storageState', 'locationStatus','saleClassification', 'pileupType','region',
  'length','width', 'height','occupiedCapacity','transferline', 'storer','weight','shortNo','containerControl',
  'automatic','locking','available']